import { Music, Volume2 } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'audio',
  renderInput: ({ value, onChange }) => {
    const url = (value as string) ?? '';
    return (
      <div className="space-y-3">
        <input
          type="url"
          value={url}
          onChange={(e) => onChange(e.target.value || null)}
          placeholder="Podaj URL pliku audio (mp3, wav, ogg)…"
          className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary placeholder:text-text-tertiary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
        />
        {url && (
          <div className="rounded-lg border border-border-primary bg-bg-secondary p-3">
            <div className="mb-2 flex items-center gap-2">
              <Volume2 className="h-4 w-4 text-text-secondary" />
              <span className="text-sm text-text-secondary">Podgląd audio</span>
            </div>
            {/* biome-ignore lint/a11y/useMediaCaption: user-provided audio, no caption source */}
            <audio controls className="w-full">
              <source src={url} />
              Twoja przeglądarka nie obsługuje odtwarzacza audio.
            </audio>
          </div>
        )}
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    return (
      <div className="flex items-center gap-2">
        <Music className="h-3.5 w-3.5 text-text-muted" />
        <span className="text-xs text-text-secondary">Audio</span>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    if (!/^https?:\/\//i.test(String(value))) return 'Nieprawidłowy URL';
    if (!/\.(mp3|wav|ogg|m4a)$/i.test(String(value)))
      return 'Plik musi być w formacie audio (mp3, wav, ogg, m4a)';
    return null;
  },
  defaultValue: null,
});
